module.exports = __webpack_public_path__ + "static/media/varnish.fc0f1b6d.png";